import { render } from "./AdminUserSetting.vue?vue&type=template&id=285097fe&ts=true"
import script from "./AdminUserSetting.vue?vue&type=script&lang=ts"
export * from "./AdminUserSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__